import axios from '@/api/axios'

const getSportEvents = () => {
  return axios.get(`/sportsEvents`)
}

const getSportEventsList = (params) => {
  return axios.get(`/sportsEvents`, {params})
}

const getSportEventsListAdmin = (params) => {
  return axios.get(`/sportsEventsListForAdmin`, {params})
}

const addSportEvent = (event) => {
  return axios.post(`/sportsEvents`, event)
}

const updateSportEvent = (event) => {
  return axios.put(`/sportsEvents/${event.id}`, event)
}

const getSportEvent = (id) => {
  return axios.get(`/sportsEvents/${id}`)
}

const deleteSportEvent = (id) => {
  return axios.delete(`/sportsEvents/${id}`)
}

const getSportsEventsTrainersList = (params) => {
  return axios.get(`/sportEvents/${params.id}/trainers`, {params})
}

const deleteSportsEventsTrainers = (id) => {
  return axios.delete(`/competition/${id}`)
}

const addSportsEventsTrainers = (trainer, id) => {
  return axios.patch(`/sportEvents/${id}/trainers`, trainer)
}

const getSportsEventsAthletesList = (params) => {
  return axios.get(`/sportEvents/${params.id}/athletes`, {params})
}

const deleteSportsEventsAthletes = (id) => {
  return axios.delete(`/sportsEvents/${id}`)
}

const addSportsEventsAthletes = (athlete, id) => {
  return axios.patch(`/sportEvents/${id}/athletes`, athlete)
}

export default {
  getSportEvents,
  getSportEventsList,
  addSportEvent,
  getSportEvent,
  updateSportEvent,
  deleteSportEvent,
  getSportEventsListAdmin,

  getSportsEventsTrainersList,
  deleteSportsEventsTrainers,
  addSportsEventsTrainers,

  getSportsEventsAthletesList,
  deleteSportsEventsAthletes,
  addSportsEventsAthletes,
}
